import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13647dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Remarks", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Create ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Restore ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_file = _resolveComponent("file")!
  const _component_comment_list = _resolveComponent("comment-list")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_loader = _resolveComponent("loader")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: _ctx.name }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        layout: "vertical",
        model: _ctx.form,
        id: "myForm",
        onFinish: _ctx.handleSaving
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: [24, 5] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Invoice Number *",
                    name: "invoice_number"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: _ctx.form.invoice_number,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.invoice_number) = $event)),
                        id: "invoice_number",
                        placeholder: "Invoice Number",
                        required: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Invoice Amount *",
                    name: "invoice_amount"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        value: _ctx.form.invoice_amount,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.invoice_amount) = $event)),
                        id: "invoice_amount",
                        placeholder: "Invoice Amount",
                        required: "",
                        step: "any"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: [24, 5] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Invoice Description ",
                    name: "invoice_description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        type: "text",
                        placeholder: "Invoice Description",
                        id: "invoice_description",
                        value: _ctx.form.invoice_description,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.invoice_description) = $event)),
                        rows: 4,
                        maxlength: "255",
                        "show-count": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "End User *",
                    name: "invoice_amount"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.form.end_user_id,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.end_user_id) = $event)),
                        "show-search": "",
                        placeholder: "Search End User",
                        "default-active-first-option": false,
                        "show-arrow": false,
                        "filter-option": false,
                        "not-found-content": _ctx.fetching ? undefined : null,
                        options: _ctx.end_users,
                        onSearch: _ctx.handleSearchEndUser,
                        onChange: _ctx.handleChangeEndUser,
                        required: ""
                      }, _createSlots({ _: 2 }, [
                        (_ctx.fetching)
                          ? {
                              name: "notFoundContent",
                              fn: _withCtx(() => [
                                _createVNode(_component_a_spin, { size: "small" })
                              ])
                            }
                          : undefined
                      ]), 1032, ["value", "not-found-content", "options", "onSearch", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "section" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_file)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.$route.path.includes('create'))
            ? (_openBlock(), _createBlock(_component_a_row, {
                key: 0,
                class: "section"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    sm: { span: 24 },
                    md: { span: 24 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse, {
                        activeKey: _ctx.activeKey,
                        "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeKey) = $event)),
                        class: "permission-collapse"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_collapse_panel, {
                            key: "1",
                            header: "Query",
                            style: {"margin-bottom":"10px","overflow":"hidden"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_comment_list)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, { style: {"text-align":"right","margin-bottom":"0","padding-top":"10px"} }, {
            default: _withCtx(() => [
              (_ctx.$route.path.includes('create'))
                ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { onClick: _ctx.back }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        key: "submit",
                        type: "primary",
                        htmlType: "submit",
                        loading: _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }))
                : (_ctx.deleted === false)
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { onClick: _ctx.back }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          key: "submit",
                          type: "primary",
                          htmlType: "submit",
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }))
                  : (_ctx.deleted === true)
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, { onClick: _ctx.back }, {
                                default: _withCtx(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_button, {
                            onClick: _ctx.restore,
                            loading: _ctx.loading,
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish"]),
      _createVNode(_component_loader, {
        title: "Uploading",
        visible: _ctx.visible_update_modal,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.visible_update_modal = false))
      }, null, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["title"]))
}